import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { memo, useState, useRef } from "react";
import PropTypes from "prop-types";
import { equals, reverse, update, compose } from "ramda";
import { MultiRangeInput as Input } from "@base-ui";
import { useDebouncedValue, useCustomEffect } from "hooks";
import { extendedSystemStylesProps } from "@mixins";
import { jsx as _jsx } from "react/jsx-runtime";
var styledSystemKeys = ["space", "layout", "flexbox"];
var MultiRangeInput = function MultiRangeInput(props) {
  var _selectable$orderedSp, _selectable$orderedSp2;
  var id = props.id,
    selectable = props.selectable,
    current = props.current,
    onChange = props.onChange,
    legend = props.legend,
    hideLegend = props.hideLegend,
    className = props.className,
    disabled = props.disabled;
  var dragging = useRef();
  var start0 = selectable.findIndex(function (x) {
    return equals(x.nameFrom, current[0].nameFrom);
  });
  var start1 = selectable.findIndex(function (x) {
    return equals(x.nameTo, current[1].nameTo);
  });
  var _useState = useState([start0, start1]),
    _useState2 = _slicedToArray(_useState, 2),
    currentStep = _useState2[0],
    setCurrentStep = _useState2[1];
  var debouncedCurrentStep = useDebouncedValue(500, currentStep);
  var calcValues = function calcValues(oldValues, value) {
    return dragging.current === "from" ? update(0, value, oldValues) : update(1, value, oldValues);
  };
  var handleOrder = function handleOrder(values) {
    return values[0] > values[1] ? reverse(values) : values;
  };
  useCustomEffect(function () {
    dragging.current = false;
    var repairedOrder = handleOrder(debouncedCurrentStep);
    if (!equals(repairedOrder, [start0, start1])) {
      onChange(repairedOrder);
    }
  }, [debouncedCurrentStep]);
  var preUpdate = function preUpdate(handle, value) {
    dragging.current = handle;
    compose(setCurrentStep, calcValues)(currentStep, value);
  };
  var orderedSpan = handleOrder(currentStep);
  return /*#__PURE__*/_jsx(Input, _objectSpread({
    id: id,
    className: className,
    legend: legend,
    label1: "Fr\xE5n: ".concat(((_selectable$orderedSp = selectable[orderedSpan[0]]) === null || _selectable$orderedSp === void 0 ? void 0 : _selectable$orderedSp.nameFrom) || "-"),
    label2: "Till: ".concat(((_selectable$orderedSp2 = selectable[orderedSpan[1]]) === null || _selectable$orderedSp2 === void 0 ? void 0 : _selectable$orderedSp2.nameTo) || "-"),
    hideLegend: hideLegend,
    steps: selectable.length - 1,
    values: currentStep,
    onChange: preUpdate,
    disabled: disabled,
    onStep: setCurrentStep
  }, extendedSystemStylesProps(styledSystemKeys, props)));
};
MultiRangeInput.propTypes = {
  id: PropTypes.string.isRequired,
  selectable: PropTypes.array.isRequired,
  current: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  legend: PropTypes.string.isRequired,
  hideLegend: PropTypes.oneOf([true, false]),
  disabled: PropTypes.bool,
  className: PropTypes.string
};
export default /*#__PURE__*/memo(MultiRangeInput, function (prev, curr) {
  return equals(curr.selectable, prev.selectable) && equals(curr.current, prev.current) && equals(curr.disabled, prev.disabled);
});